import React, { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';

import TitleBar from '../../titleBar/titleBar';
import AgGridTable from '../../agGridComponent/agGridTable';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder'
import { getTarget, deleteTarget } from '../../../redux/actions/targetMasterActions';
import TargetActionButton from './targetActionButton';
import { FEATURES } from '../../utils/constants';


function TargetTable(props) {
    
    const { targetData, targetLoading, getTarget, deleteTarget } = props;
    useEffect(() => {
        getTarget()
    }, [getTarget]);


    if(targetLoading){
        return (
            <React.Fragment>
                <TitleBar title="Target" LinkName="" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            { headerName: 'Target Receivable Amount', field: 'target_receivable_amt', tooltipField: 'targetCode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Target Sales Amount', field: 'target_sales_amt', tooltipField: 'targetName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Target Payment Ex Amount', field: 'target_payment_ex', tooltipField: 'targetName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Target Sales Number', field: 'target_sales_no', tooltipField: 'targetName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Month', field: 'month', tooltipField: 'month', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Year', field: 'year', tooltipField: 'targetAddress', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true }
        ] 
        
        let frameworkComponents = {
            actionRenderer: TargetActionButton,
        }

        let rowData = []

        targetData && targetData.forEach((object, index) => {
            let temp = {}
            temp.id = object.id
            temp.target_receivable_amt = object.target_receivable_amt
            temp.target_sales_amt = object.target_sales_amt
            temp.target_payment_ex = object.target_payment_ex
            temp.target_sales_no = object.target_sales_no
            temp.month = object.month
            temp.year = object.year
            temp.deleteTarget = deleteTarget
            rowData[index] = temp
        })
        

        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    link="/add-target"
                    baseURL={props}
                    hiddenNewPopupBtn={true}
                    newPopup={props.newPopup}   
                    hiddenImportPopupBtn={true}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Target"
                    handleSearch={props.handleSearch}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    targetData: state.getTargetData.target.data,
    targetLoading: state.getTargetData.isLoading
})

export default connect(mapStatetoProps, { getTarget,
    deleteTarget
 })(TargetTable)